import { isAfter } from 'date-fns'

import { nowWithTimezone } from '@/shared/lib'

export const isReservationLate = (endDate: Date) => {
  return isAfter(nowWithTimezone(), endDate)
}
